module.exports = __webpack_public_path__ + "static/media/party-background.142648a6.png";